import firebase from "../../config/firebase";

export const fetchCollegeStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_COLLEGE_STATES",
        payload: tempStates,
      });
    });
};

export const fetchSchoolStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("school_states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_SCHOOL_STATES",
        payload: tempStates,
      });
    });
};

export const getCollegeCity = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("state", "==", state)
    .orderBy("city", "asc")
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_CITY_BY_STATE", payload: temp });
    });
};

export const getSchoolCounty = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    .orderBy("county", "asc")
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_COUNTY_BY_STATE", payload: temp });
    });
};

export const getCollegeNameByStateAndCity =
  (state, city) => async (dispatch) => {
    firebase
      .firestore()
      .collection("test-colleges-universities")
      .where("state", "==", state)
      .where("city", "==", city)
      .onSnapshot((query) => {
        let temp = [];
        query.forEach((doc) => {
          temp.push({
            ...doc.data(),
          });
        });
        dispatch({ type: "GET_COLLEGE_NAME_BY_STATE_AND_CITY", payload: temp });
      });
  };

export const getSchoolNameByStateAndCounty =
  (state, county) => async (dispatch) => {
    firebase
      .firestore()
      .collection("test_schools")
      .where("state", "==", state)
      .where("county", "==", county)
      .onSnapshot((query) => {
        let temp = [];
        query.forEach((doc) => {
          temp.push({
            ...doc.data(),
          });
        });
        dispatch({ type: "GET_SCHOOL_BY_STATE_AND_COUNTY", payload: temp });
      });
  };
